import { removeLinkPreview } from './BaseLinkPreviewObject.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import * as Constants from './constants';
import { Icon } from '@fluentui/react/lib/Icon';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

let closeButtonStyles = require('../styles/closeButtonStyle.scss');

export enum LinkPreviewType {
    WebpagePreview,
    VideoPreview,
}

export interface BaseLinkPreviewObject {
    type: LinkPreviewType;

    title: string;
    thumbnailImageUrl: string;
    description: string;
    url: string;

    anchor?: HTMLAnchorElement;
    border?: HTMLDivElement;
    closeButtonContainer?: HTMLDivElement;
}

export function createLinkPreviewBorder(previewType: string, lp: BaseLinkPreviewObject) {
    // Encode the url and put it in the border id. This is used by the jsmvvm implementation of
    // link previews when rehydrating previews in the reading pane
    let encodedUrl = window.btoa(lp.url);
    encodedUrl = encodedUrl.replace(new RegExp('\\+', 'g'), '-');
    encodedUrl = encodedUrl.replace(new RegExp('/', 'g'), ':');
    encodedUrl = encodedUrl.replace(new RegExp('=', 'g'), '.');

    lp.border = document.createElement('div');
    lp.border.id = `${Constants.LINK_PREVIEW_BORDER_ID_BASE}_${previewType}${encodedUrl}`;
    // Since the link preview border id is already in use for when a link preview is sent from
    // jsmvvm but opened in React, use the class instead to store an id shared across
    // all elements within the link preview border. This will be used for link preview removal
    lp.border.className =
        Constants.LINK_PREVIEW_BORDER_ID_BASE + Constants.createLinkPreviewIdNumber();
    setStyleForBorder(lp.border);
}

export function addCloseButton(lp: BaseLinkPreviewObject) {
    lp.closeButtonContainer = document.createElement('div');
    lp.closeButtonContainer.id = Constants.createLinkPreviewId(
        lp.border.className,
        Constants.LINK_PREVIEW_CLOSE_BUTTON_CONTAINER_ID
    );
    lp.closeButtonContainer.className = closeButtonStyles.closeButtonContainer;
    lp.closeButtonContainer.tabIndex = 0;
    lp.closeButtonContainer.title = loc(removeLinkPreview);
    lp.closeButtonContainer.setAttribute('role', 'button');

    ReactDOM.render(
        <Icon
            id={Constants.createLinkPreviewId(
                lp.border.className,
                Constants.LINK_PREVIEW_CLOSE_BUTTON_ID
            )}
            className={closeButtonStyles.icon}
            iconName={ControlIcons.Cancel}
        />,
        lp.closeButtonContainer
    );

    lp.border.appendChild(lp.closeButtonContainer);
}

function setStyleForBorder(element: HTMLElement) {
    element.style.width = '100%';
    element.style.marginTop = '16px';
    element.style.marginBottom = '16px';
    element.style.position = 'relative';
    element.style.maxWidth = '800px';
    element.style.minWidth = '424px';
}
